import { render, staticRenderFns } from "./DropdownField.vue?vue&type=template&id=1e544188&"
import script from "./DropdownField.vue?vue&type=script&lang=js&"
export * from "./DropdownField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e544188')) {
      api.createRecord('1e544188', component.options)
    } else {
      api.reload('1e544188', component.options)
    }
    module.hot.accept("./DropdownField.vue?vue&type=template&id=1e544188&", function () {
      api.rerender('1e544188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/custom-fields/DropdownField.vue"
export default component.exports